module.exports = __webpack_public_path__ + "img/1003_pc.1acdbe8b.gif";